<template>
	<div class="width-100 display-flex flex-column">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between">
			<div class="display-flex flex-column">
				<div class="field-text">{{ title }}</div>
				<div v-if="description" class="description-text">{{ description }}</div>
			</div>
		</div>
		<CombinedInputFieldDataMenu
			:placeholder="placeholder"
			:value.sync="textFieldValueLocal"
			:valuesTypes="ITEM_ONLY_ALLOWED_VALUE_TYPES"
			:prefixStyle="prefixStyle"
			:suffixStyle="suffixStyle"
			@content-updated="() => null"
			@remove="() => $emit('removeOption', localData)"
		/>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';

import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import { ITEM_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';

export default {
	name: 'SettingTextDataInput',
	components: { CombinedInputFieldDataMenu },
	props: {
		title: { type: String },
		description: { type: String },
		placeholder: { type: String },
		textFieldValue: { type: String },
	},
	data() {
		return { ITEM_ONLY_ALLOWED_VALUE_TYPES };
	},
	computed: {
		textFieldValueLocal: {
			get() {
				return this.textFieldValue;
			},
			set: debounce(function (value) {
				this.$emit('update:textFieldValue', value);
			}, 500),
		},
		prefixStyle() {
			return { 'margin-left': '22px !important' };
		},
		suffixStyle() {
			return { 'margin-right': '22px !important', 'margin-top': '-1px !important' };
		},
	},
	methods: {
		focusInput() {
			this.$refs.mainInput.$el.getElementsByTagName('input')[0].focus();
		},
	},
};
</script>
<style scoped lang="scss">
.field-text {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}

.description-text {
	font-size: 12px;
	font-weight: normal;
	color: var(--secondary-font-color);
}
</style>
